import { useState } from "react";
import Select from "react-select";

function OfferPosgrados() {
  const [periodo, setPeriodo] = useState(null);
  const [modalidad, setModalidad] = useState(null);
  const [tipo, setTipo] = useState(null);
  const [campo, setCampo] = useState(null);

  const optionsoferta = [
    { value: "todos", label: "Toda la oferta" },
    { value: "octubre 2025 - febrero 2026", label: "Vigente" },
    { value: "abril - agosto 2026", label: "Próxima" },
  ];

  const optionsmodalidad = [
    { value: "todos", label: "Todas las modalidades" },
    { value: "en línea", label: "En línea" },
    { value: "presencial", label: "Presencial" },
    { value: "híbrida", label: "Híbrida" },
  ];

  const optionstipo = [
    { value: "todos", label: "Todas los programas" },
    { value: "Especialización", label: "Especialización" },
    { value: "Maestría", label: "Maestría" },
    { value: "Doctorado", label: "Doctorado" },
  ];

  const optionscampo = [
    { value: "todos", label: "Todos los programas" },
    { value: "Administración", label: "Administración" },
    {
      value: "Administración de Empresas y Derecho",
      label: "Administración de Empresas y Derecho",
    },
    {
      value: "Ciencias Naturales, Matemáticas y Estadística",
      label: "Ciencias Naturales, Matemáticas y Estadística",
    },
    {
      value: "Ciencias Sociales, Periodismo, Información y Derecho",
      label: "Ciencias Sociales, Periodismo, Información y Derecho",
    },

    {
      value: "Educación",
      label: "Educación",
    },
    {
      value: "Educación Comercial y Administración",
      label: "Educación Comercial y Administración",
    },

    {
      value: "Ingeniería, Industria y Construcción",
      label: "Ingeniería, Industria y Construcción",
    },
    {
      value: "Servicios",
      label: "Servicios",
    },
    {
      value: "Salud y Bienestar",
      label: "Salud y Bienestar",
    },
    {
      value: "Tecnologías de la Información y la Comunicación (TIC)",
      label: "Tecnologías de la Información y la Comunicación (TIC)",
    },
  ];

  function IsTag(data) {
    if (data && data.trim && data.trim() !== "") {
      return <p className="tag-2">{data}</p>;
    }
    return null; // Renderiza nada si data está vacío
  }

  const programas = [
    {
      titulo: "Bioeconomía",
      modalidad: "en línea",
      duracion: "1 año",
      facultad: "Facultad de Ciencias Exactas y Naturales",
      campo: "Ciencias Naturales, Matemáticas y Estadística",
      tipo: "Maestría",
      imagen:
        "https://www.utpl.edu.ec/maestrias/sites/default/files/portada_1.jpg",
      url: "https://utpl.edu.ec/maestria-bioeconomia",
      periodo: "octubre 2025 - febrero 2026",
      inicio: "octubre 2025",
      tag: "Programa nuevo",
    },
    {
      titulo: "Ciencias Químicas",
      modalidad: "presencial",
      duracion: "1 año",
      facultad: "Facultad de Ciencias Exactas y Naturales",
      campo: "Ciencias Naturales, Matemáticas y Estadística",
      tipo: "Maestría",
      imagen:
        "https://www.utpl.edu.ec/maestrias/sites/default/files/ciencias-quimicas-2.jpg",
      url: "https://www.utpl.edu.ec/maestrias/ciencias-quimicas",
      periodo: "octubre 2025 - febrero 2026",
      inicio: "octubre 2025",
    },
/*     {
      titulo: "Ciencias Ambientales con mención en Educación Ambiental",
      modalidad: "en línea",
      duracion: "1 año",
      facultad: "Facultad de Ciencias Exactas y Naturales",
      campo: "Medio ambiente",
      tipo: "Maestría",
      imagen:
        "https://www.utpl.edu.ec/maestrias/sites/default/files/ciencias-portada.png",
      url: "http://utpl.edu.ec/maestria-ciencias-ambientales",
      periodo: "octubre 2025 - febrero 2026",
      inicio: "octubre 2025",
    }, */
    {
      titulo: "Comunicación Estratégica mención Comunicación Digital",
      modalidad: "en línea",
      duracion: "1 año",
      facultad: "Facultad de Ciencias Sociales, Educación y Humanidades",
      campo: "Ciencias Sociales, Periodismo, Información y Derecho",
      tipo: "Maestría",
      imagen:
        "https://www.utpl.edu.ec/maestrias/sites/default/files/comunicacion%20cabecera-100.jpg",
      url: "https://utpl.edu.ec/maestria-comunicacion-estrategica",
      periodo: "octubre 2025 - febrero 2026",
      inicio: "octubre 2025",
    },
  /*   {
      titulo: "Cooperación Internacional para el Desarrollo Sostenible",
      modalidad: "en línea",
      duracion: "1 año",
      facultad: "Facultad de Ciencias Económicas y Empresariales",
      campo: "Ciencias Sociales, Periodismo, Información y Derecho",
      tipo: "Maestría",
      imagen:
        "https://www.utpl.edu.ec/maestrias/sites/default/files/sostenible%20cabecera-100.jpg",
      url: "https://www.utpl.edu.ec/maestrias/cooperacion",
      periodo: "octubre 2025 - febrero 2026",
      inicio: "octubre 2025",
    }, */
    {
      titulo: "Derecho Constitucional",
      modalidad: "en línea",
      duracion: "1 año",
      facultad: "Facultad de Ciencias Jurídicas y Políticas",
      campo: "Ciencias Sociales, Periodismo, Información y Derecho",
      tipo: "Maestría",
      imagen:
        "https://www.utpl.edu.ec/maestrias/sites/default/files/constitucional%20cabecera-100.jpg",
      url: "https://www.utpl.edu.ec/maestrias/constitucional",
      periodo: "octubre 2025 - febrero 2026",
      inicio: "octubre 2025",
    },
    {
      titulo: "Derecho mención Derecho Procesal",
      modalidad: "en línea",
      duracion: "1 año",
      facultad: "Facultad de Ciencias Jurídicas y Políticas",
      campo: "Ciencias Sociales, Periodismo, Información y Derecho",
      tipo: "Maestría",
      imagen:
        "https://www.utpl.edu.ec/maestrias/sites/default/files/Maestri%CC%81a%20en%20Derecho%2C%20mencio%CC%81n%20Derecho%20Procesal-.jpg",
      url: "https://www.utpl.edu.ec/maestrias/procesal",
      periodo: "octubre 2025 - febrero 2026",
      inicio: "octubre 2025",
    },
    {
      titulo: "Derecho Penal mención Derecho Procesal Penal",
      modalidad: "en línea",
      duracion: "1 año",
      facultad: "Facultad de Ciencias Jurídicas y Políticas",
      campo: "Ciencias Sociales, Periodismo, Información y Derecho",
      tipo: "Maestría",
      imagen:
        "https://www.utpl.edu.ec/maestrias/sites/default/files/penal%20cabecera-100.jpg",
      url: "https://www.utpl.edu.ec/maestrias/penal",
      periodo: "octubre 2025 - febrero 2026",
      inicio: "octubre 2025",
      tag:"Cupos cerrados"
    },
    {
      titulo: "Derecho Procesal Administrativo",
      modalidad: "en línea",
      duracion: "1 año",
      facultad: "Facultad de Ciencias Jurídicas y Políticas",
      campo: "Administración de Empresas y Derecho",
      tipo: "Maestría",
      imagen:
        "https://www.utpl.edu.ec/maestrias/sites/default/files/derecho-admin.png",
      url: "https://utpl.edu.ec/maestria-derecho-administrativo",
      periodo: "octubre 2025 - febrero 2026",
      inicio: "octubre 2025",
      tag: "Cupos cerrados",
    },
    {
      titulo: "Derecho Tributario",
      modalidad: "en línea",
      duracion: "1 año",
      facultad: "Facultad de Ciencias Jurídicas y Políticas",
      campo: "Administración de Empresas y Derecho",
      tipo: "Maestría",
      imagen:
        "https://www.utpl.edu.ec/maestrias/sites/default/files/Dise%C3%B1o%20sin%20t%C3%ADtulo%20%282%29_2.png",
      url: "https://utpl.edu.ec/maestria-derecho-tributario",
      periodo: "octubre 2025 - febrero 2026",
      inicio: "octubre 2025",
      tag: "Programa nuevo",
    },

    {
      titulo: "Dirección Financiera con mención en Fintech",
      modalidad: "en línea",
      duracion: "1 año",
      facultad: "EDES Escuela de Negocios",
      campo: "Administración de Empresas y Derecho",
      tipo: "Maestría",
      imagen:
        "https://www.utpl.edu.ec/maestrias/sites/default/files/direccion-financiera-edes.png",
      url: "https://edes.utpl.edu.ec/oferta-academica/maestrias/direccion-financiera-con-mencion-en-fintech",
      periodo: "octubre 2025 - febrero 2026",
      inicio: "octubre 2025",
    },

    {
      titulo: "Educación con mención en Literatura Infantil y Juvenil",
      modalidad: "en línea",
      duracion: "1 año",
      facultad: "Facultad de Ciencias Sociales, Educación y Humanidades",
      campo: "Educación",
      tipo: "Maestría",
      imagen:
        "https://www.utpl.edu.ec/maestrias/sites/default/files/cabecera%20maestri%CC%81a%20en%20Educacio%CC%81n%20con%20mencio%CC%81n%20en%20Literatura%20Infantul%20y%20Juvenil.jpg",
      url: "https://utpl.edu.ec/maestria-literatura",
      periodo: "octubre 2025 - febrero 2026",
      inicio: "octubre 2025",
      tag: "Programa nuevo",
    },

    {
      titulo:
        "Educación con mención en Inclusión Educativa y Atención a la Diversidad ",
      modalidad: "en línea",
      duracion: "1 año",
      facultad: "Facultad de Ciencias Sociales, Educación y Humanidades",
      campo: "Educación",
      tipo: "Maestría",
      imagen:
        "https://www.utpl.edu.ec/maestrias/sites/default/files/cabecera-maestria-inclusion-educativa.png",
      url: "https://utpl.edu.ec/maestria-educacion-inclusiva",
      periodo: "octubre 2025 - febrero 2026",
      inicio: "octubre 2025",
      tag: "Programa nuevo",
    },

    {
      titulo: "Educación mención Enseñanza de la Matemática",
      modalidad: "en línea",
      duracion: "1 año",
      facultad: "Facultad de Ciencias Sociales, Educación y Humanidades",
      campo: "Educación",
      tipo: "Maestría",
      imagen:
        "https://www.utpl.edu.ec/maestrias/sites/default/files/Maestri%CC%81a%20en%20Educacio%CC%81n%2C%20mencio%CC%81n%20Ensen%CC%83anza%20de%20la%20Matema%CC%81tica-.jpg",
      url: "https://www.utpl.edu.ec/maestrias/matematica",
      periodo: "octubre 2025 - febrero 2026",
      inicio: "octubre 2025",
    },
    {
      titulo:
        "Especialización en Ingeniería Civil con mención en Mecánica de Suelos Avanzada",
      modalidad: "híbrida",
      duracion: "6 meses",
      facultad: "Facultad de Ingenierías y Arquitectura",
      campo: "Ingeniería, Industria y Construcción",
      tipo: "Especialización",
      imagen:
        "https://www.utpl.edu.ec/maestrias/sites/default/files/especializacion-mecanica-avanzada_0.png",
      url: "https://utpl.edu.ec/especializacion-mecanica-suelos",
      periodo: "octubre 2025 - febrero 2026",
      inicio: "octubre 2025",
      tag: "Programa nuevo",
    },
    {
      titulo: "Especialización en Geotecnia",
      modalidad: "híbrida",
      duracion: "6 meses",
      facultad: "Facultad de Ingenierías y Arquitectura",
      campo: "Ciencias Naturales, Matemáticas y Estadística",
      tipo: "Especialización",
      imagen:
        "https://www.utpl.edu.ec/maestrias/sites/default/files/lugar-de-construccion-en-la-ciudad-contra-el-cielo-durante-la-puesta-de-sol.jpg",
      url: "https://utpl.edu.ec/especializacion-geotecnia",
      periodo: "octubre 2025 - febrero 2026",
      inicio: "octubre 2025",
      tag: "Programa nuevo",
    },
    {
      titulo:
        "Especialización en Gestión de Geoinformación con mención en proyectos de Ingeniería",
      modalidad: "en línea",
      duracion: "6 meses",
      facultad: "Facultad de Ingenierías y Arquitectura",
      campo: "Tecnologías de la Información y la Comunicación (TIC)",
      tipo: "Especialización",
      imagen:
        "https://www.utpl.edu.ec/maestrias/sites/default/files/cabecera%20geoinformacin%281%29_0.jpg",
      url: "https://utpl.edu.ec/especializacion-geoinformacion",
      periodo: "octubre 2025 - febrero 2026",
      inicio: "octubre 2025",
    },
    {
      titulo:
        "Especialización en Ingeniería Civil con mención en Alcantarillados y Saneamiento",
      modalidad: "híbrida",
      duracion: "6 meses",
      facultad: " Facultad de Ingenierías y Arquitectura",
      campo: "Ingeniería, Industria y Construcción",
      tipo: "Especialización",
      imagen:
        "https://www.utpl.edu.ec/maestrias/sites/default/files/portada_0.jpg",
      url: "https://www.utpl.edu.ec/especializacion-alcantarillado",
      periodo: "octubre 2025 - febrero 2026",
      inicio: "octubre 2025",
    },
    {
      titulo: "Especialización en Ingeniería Civil con mención en Vías",
      modalidad: "híbrida",
      duracion: "6 meses",
      facultad: " Facultad de Ingenierías y Arquitectura",
      campo: "Ingeniería, Industria y Construcción",
      tipo: "Especialización",
      imagen:
        "https://www.utpl.edu.ec/maestrias/sites/default/files/especializacion%20vias-color.png",
      url: "https://utpl.edu.ec/especializacion-vias",
      periodo: "octubre 2025 - febrero 2026",
      inicio: "octubre 2025",
    },

    {
      titulo: "Especialización en Optimización y Dirección Logística",
      modalidad: "en línea",
      duracion: "6 meses",
      facultad: "Facultad de Ingenierías y Arquitectura",
      campo: "Ciencias Naturales, Matemáticas y Estadística",
      tipo: "Especialización",
      imagen:
        "https://www.utpl.edu.ec/maestrias/sites/default/files/logistica_foto_portada.png",
      url: "https://www.utpl.edu.ec/especializacion-logistica",
      periodo: "octubre 2025 - febrero 2026",
      inicio: "octubre 2025",
      tag: "Programa nuevo",
    },
/*     {
      titulo: "Especialización en Patrimonio Paleontológico",
      modalidad: "híbrida",
      duracion: "6 meses",
      facultad: "Facultad de Ingenierías y Arquitectura",
      campo: "Ciencias Naturales, Matemáticas y Estadística",
      tipo: "Especialización",
      imagen:
        "https://www.utpl.edu.ec/maestrias/sites/default/files/1200x600_paleontologia.jpg",
      url: "https://www.utpl.edu.ec/especializacion-patrimonio-paleontologico",
      periodo: "octubre 2025 - febrero 2026",
      inicio: "octubre 2025",
      tag: "Programa nuevo",
    }, 
    {
      titulo:
        "Especialización en Sistemas de Información con mención en Blockchain y Arquitectura en la Nube",
      modalidad: "en línea",
      duracion: "6 meses",
      facultad: "Facultad de Ingenierías y Arquitectura",
      campo: "Tecnologías de la Información y la Comunicación (TIC)",
      tipo: "Especialización",
      imagen:
        "https://www.utpl.edu.ec/maestrias/sites/default/files/Dise%C3%B1o%20sin%20t%C3%ADtulo_6.png",
      url: "https://utpl.edu.ec/especializacion-blockchain",
      periodo: "octubre 2025 - febrero 2026",
      inicio: "octubre 2025",
      tag: "Programa nuevo",
    },*/
    {
      titulo: "Especialización en Tributación",
      modalidad: "en línea",
      duracion: "6 meses",
      facultad: "Facultad de Ciencias Económicas y Empresariales",
      campo: "Administración de Empresas y Derecho",
      tipo: "Especialización",
      imagen:
        "https://www.utpl.edu.ec/maestrias/sites/default/files/cabecera%20Especializacio%CC%81n%20en%20Tributacio%CC%81n%202_0.jpg",
      url: "https://utpl.edu.ec/especializacion-tributacion",
      periodo: "octubre 2025 - febrero 2026",
      inicio: "octubre 2025",
      tag: "Programa nuevo",
    },
    {
      titulo: "Especialización en Medicina Familiar y Comunitaria",
      modalidad: "presencial",
      duracion: "3 años",
      facultad: " Facultad de Ciencias de la Salud",
      campo: "Salud y Bienestar",
      tipo: "Especialización",
      imagen:
        "https://www.utpl.edu.ec/maestrias/sites/default/files/cabecera-especialidad.png",
      url: "https://www.utpl.edu.ec/especializacion-medicina-familiar",
      periodo: "octubre 2025 - febrero 2026",
      inicio: "octubre 2025",
    },
    {
      titulo:
        "Farmacia Asistencial y Atención Farmacéutica con mención en Medicamentos",
      modalidad: "híbrida",
      duracion: "1 año",
      facultad: "Facultad de Ciencias de la Salud",
      campo: "Salud y Bienestar",
      tipo: "Maestría",
      imagen:
        "https://www.utpl.edu.ec/maestrias/sites/default/files/farmacia-1_0.png",
      url: "https://utpl.edu.ec/maestria-farmacia-asistencial",
      periodo: "octubre 2025 - febrero 2026",
      inicio: "octubre 2025",
      tag: "Cupos cerrados",
    },
    {
      titulo: "Gerencia de Instituciones de Salud",
      modalidad: "en línea",
      duracion: "1 año",
      facultad: "Facultad de Ciencias de la Salud",
      campo: "Administración",
      tipo: "Maestría",
      imagen:
        "https://www.utpl.edu.ec/maestrias/sites/default/files/maestria-gerencia.jpg",
      url: "https://www.utpl.edu.ec/maestrias/gerencia",
      periodo: "octubre 2025 - febrero 2026",
      inicio: "octubre 2025",
    },

    {
      titulo: "Gestión de la Calidad y Auditoría en Salud",
      modalidad: "en línea",
      duracion: "1 año",
      facultad: "Facultad de Ciencias de la Salud",
      campo: "Administración",
      tipo: "Maestría",
      imagen:
        "https://www.utpl.edu.ec/maestrias/sites/default/files/maestria-gestion.jpg",
      url: "https://www.utpl.edu.ec/maestrias/gestion",
      periodo: "octubre 2025 - febrero 2026",
      inicio: "octubre 2025",
    },
    {
      titulo: "Gestión e Innovación de Alimentos y Bebidas",
      modalidad: "en línea",
      duracion: "1 año",
      facultad: "Facultad de Ciencias Económicas y Empresariales",
      campo: "Servicios",
      tipo: "Maestría",
      imagen:
        "https://www.utpl.edu.ec/maestrias/sites/default/files/cabecera-alimentos.jpg",
      url: "https://www.utpl.edu.ec/maestrias/gestion-alimentos",
      periodo: "octubre 2025 - febrero 2026",
      inicio: "octubre 2025",
    },
    {
      titulo: "Gestión Financiera y Administración de Riesgos Financieros",
      modalidad: "en línea",
      duracion: "1 año",
      facultad: "Facultad de Ciencias Económicas y Empresariales",
      campo: "Educación Comercial y Administración",
      tipo: "Maestría",
      imagen:
        "https://www.utpl.edu.ec/maestrias/sites/default/files/Dise%C3%B1o%20sin%20t%C3%ADtulo%20%281%29_3.png",
      url: "http://utpl.edu.ec/maestria-gestion-financiera",
      periodo: "octubre 2025 - febrero 2026",
      inicio: "octubre 2025",
      tag: "Cupos cerrados",

    },
    {
      titulo: "Gestión Integrada de Recursos Hídricos",
      modalidad: "en línea",
      duracion: "1 año",
      facultad: " Facultad de Ingenierías y Arquitectura",
      campo: " Ciencias Naturales, Matemáticas y Estadística",
      tipo: "Maestría",
      imagen:
        "https://www.utpl.edu.ec/maestrias/sites/default/files/recursos-hidricos-2.jpg",
      url: "https://www.utpl.edu.ec/maestrias/recursos-hidricos",
      periodo: "octubre 2025 - febrero 2026",
      inicio: "octubre 2025",
    },
    {
      titulo:
        "Geología con mención en Exploración y Evaluación de Recursos Mineros",
      modalidad: "híbrida",
      duracion: "1 año",
      facultad: "Facultad de Ingenierías y Arquitectura",
      campo: "Ciencias Naturales, Matemáticas y Estadística",
      tipo: "Maestría",
      imagen:
        "https://www.utpl.edu.ec/maestrias/sites/default/files/portada-geologia-new.jpg",
      url: "https://www.utpl.edu.ec/maestria-geologia",
      periodo: "octubre 2025 - febrero 2026",
      inicio: "octubre 2025",
      tag: "Cupos cerrados",
    },
    {
      titulo: "Gestión Empresarial",
      modalidad: "en línea",
      duracion: "1 año",
      facultad: "Edes Escuela de Negocios",
      campo: "Administración",
      tipo: "Maestría",
      imagen:
        "https://www.utpl.edu.ec/maestrias/sites/default/files/gestion-empresarial-edes.png",
      url: "https://edes.utpl.edu.ec/oferta-academica/maestrias/gestion-empresarial",
      periodo: "octubre 2025 - febrero 2026",
      inicio: "octubre 2025",
    },

    {
      titulo: "Gestión del Talento Humano con Mención en Management 3.0",
      modalidad: "en línea",
      duracion: "1 año",
      facultad: "Edes Escuela de Negocios",
      campo: "Administración",
      tipo: "Maestría",
      imagen:
        "https://www.utpl.edu.ec/maestrias/sites/default/files/talento-humano-edes.png",
      url: "https://edes.utpl.edu.ec/oferta-academica/maestrias/gestion-del-talento-humano",
      periodo: "octubre 2025 - febrero 2026",
      inicio: "octubre 2025",
    },
    {
      titulo: "Investigación en Educación",
      modalidad: "en línea",
      duracion: "1 año",
      facultad: "Facultad de Ciencias Sociales, Educación y Humanidades",
      campo: "Educación",
      tipo: "Maestría",
      imagen:
        "https://www.utpl.edu.ec/maestrias/sites/default/files/investigacion1.png",
      url: "https://www.utpl.edu.ec/maestria-investigacion-educacion",
      periodo: "octubre 2025 - febrero 2026",
      inicio: "octubre 2025",
    },

    {
      titulo: "Marketing mención en Transformación Digital",
      modalidad: "en línea",
      duracion: "1 año",
      facultad: "EDES Escuela de negocios",
      campo: "Administración de Empresas y Derecho",
      tipo: "Maestría",
      imagen:
        "https://www.utpl.edu.ec/maestrias/sites/default/files/marketing-edes.png",
      url: "https://edes.utpl.edu.ec/oferta-academica/maestrias/marketing-con-mencion-en-transformacion-digital",
      periodo: "octubre 2025 - febrero 2026",
      inicio: "octubre 2025",
    },

    {
      titulo: "MBA con mención en Transformación Digital",
      modalidad: "en línea",
      duracion: "1 año",
      facultad: "EDES Escuela de negocios",
      campo: "Administración",
      tipo: "Maestría",
      imagen:
        "https://www.utpl.edu.ec/maestrias/sites/default/files/mba-transformacion-digital-edes.png",
      url: "https://edes.utpl.edu.ec/maestria-transformacion-digital",
      periodo: "octubre 2025 - febrero 2026",
      inicio: "octubre 2025",
    },

  /*   {
      titulo: "MBA con mención en Innovación - presencial",
      modalidad: "presencial",
      duracion: "1 año",
      facultad: "EDES Escuela de negocios",
      campo: "Administración",
      tipo: "Maestría",
      imagen:
        "https://www.utpl.edu.ec/maestrias/sites/default/files/mba-presencial-edes.png",
      url: "https://edes.utpl.edu.ec/oferta-academica/maestrias/mba-presencial",
      periodo: "octubre 2025 - febrero 2026",
      inicio: "octubre 2025",
    }, */
    {
      titulo: "MBA con mención en Innovación - en línea",
      modalidad: "presencial",
      duracion: "1 año",
      facultad: "EDES Escuela de negocios",
      campo: "Administración",
      tipo: "Maestría",
      imagen:
        "https://www.utpl.edu.ec/maestrias/sites/default/files/mba-enlinea-edes.png",
      url: "https://edes.utpl.edu.ec/oferta-academica/maestrias/mba-a-distancia",
      periodo: "octubre 2025 - febrero 2026",
      inicio: "octubre 2025",
    },

    {
      titulo:
        "Pedagogía de los Idiomas Nacionales y Extranjeros, mención Enseñanza de Inglés",
      modalidad: "en línea",
      duracion: "1 año",
      facultad: "Facultad de Ciencias Sociales, Educación y Humanidades",
      campo: "Educación",
      tipo: "Maestría",
      imagen:
        "https://www.utpl.edu.ec/maestrias/sites/default/files/ingles%20cabecera-100.jpg",
      url: "https://www.utpl.edu.ec/maestrias/ingles",
      periodo: "octubre 2025 - febrero 2026",
      inicio: "octubre 2025",
    },
    {
      titulo: "Pedagogía en las Artes",
      modalidad: "en línea",
      duracion: "1 año",
      facultad: "Facultad de Ciencias Sociales, Educación y Humanidades",
      campo: "Educación",
      tipo: "Maestría",
      imagen:
        "https://www.utpl.edu.ec/maestrias/sites/default/files/artes%20cabecera-100.jpg",
      url: "https://www.utpl.edu.ec/maestrias/artes",
      periodo: "octubre 2025 - febrero 2026",
      inicio: "octubre 2025",
    },
    {
      titulo: "Seguridad Industrial mención Prevención de Riesgos Laborales",
      modalidad: "en línea",
      duracion: "1 año",
      facultad: "Facultad de Ciencias Exactas y Naturales",
      campo: "Ingeniería, Industria y Construcción",
      tipo: "Maestría",
      imagen:
        "https://www.utpl.edu.ec/maestrias/sites/default/files/cabecera%20riesgos%20laborales.jpg",
      url: "https://www.utpl.edu.ec/maestrias/seguridad",
      periodo: "octubre 2025 - febrero 2026",
      inicio: "octubre 2025",
      tag:"Cupos cerrados",
    },

    {
      titulo: "Análisis Biológico y Diagnóstico de Laboratorio",
      modalidad: "presencial",
      duracion: "1 año",
      facultad: "Facultad de Ciencias de la Salud",
      campo: "Ciencias Naturales, Matemáticas y Estadística",
      tipo: "Maestría",
      imagen: "",
      url: "https://utpl.edu.ec/maestria-analisis-biologico",
      periodo: "abril - agosto 2026",
      inicio: "abril 2026",
    },
    {
      titulo: "Análisis y Gestión de Datos para la Economía y la Empresa",
      modalidad: "en línea",
      duracion: "1 año",
      facultad: "Facultad de Ciencias Económicas y Empresariales",
      campo: "Ciencias Sociales, Periodismo e Información",
      tipo: "Maestría",
      imagen: "",
      url: "https://www.utpl.edu.ec/maestria-datos",
      periodo: "abril - agosto 2026",
      inicio: "abril 2026",
    },
    {
      titulo:
        "Auditoría con mención en Gestión del Riesgo de Fraude Financiero y Auditoría Forense",
      modalidad: "en línea",
      duracion: "1 año",
      facultad: "Facultad de Ciencias Económicas y Empresariales",
      campo: "Administración de Empresas y Derecho",
      tipo: "Maestría",
      imagen: "",
      url: "https://www.utpl.edu.ec/maestrias/auditoria",
      periodo: "abril - agosto 2026",
      inicio: "abril 2026",
    },
    {
      titulo: "Ciencias Políticas con mención en Políticas Públicas",
      modalidad: "en línea",
      duracion: "1 año",
      facultad: "Facultad de Ciencias Jurídicas y Políticas",
      campo: "Ciencias Sociales, Periodismo, Información y Derecho",
      tipo: "Maestría",
      imagen: "",
      url: "https://www.utpl.edu.ec/maestria-ciencias-politicas",
      periodo: "abril - agosto 2026",
      inicio: "abril 2026",
    },
    {
      titulo:
        "Comunicación, Ideación y Creación de Contenidos con Inteligencia Artificial",
      modalidad: "en línea",
      duracion: "1 año",
      facultad: "Facultad de Ciencias Sociales, Educación y Humanidades",
      campo: "Ciencias Sociales, Periodismo e Información",
      tipo: "Maestría",
      imagen: "",
      url: "https://www.utpl.edu.ec/maestria-comunicacion-ia",
      periodo: "abril - agosto 2026",
      inicio: "abril 2026",
    },
    {
      titulo: "Criminología y Política Criminal",
      modalidad: "en línea",
      duracion: "1 año",
      facultad: "Facultad de Ciencias Jurídicas y Políticas",
      campo: "Administración de Empresas y Derecho",
      tipo: "Maestría",
      imagen: "",
      url: "https://www.utpl.edu.ec/maestrias/criminologia",
      periodo: "abril - agosto 2026",
      inicio: "abril 2026",
    },
    {
      titulo: "Educación con Mención en Currículo y Evaluación Educativa",
      modalidad: "en línea",
      duracion: "1 año",
      facultad: "Facultad de Ciencias Sociales, Educación y Humanidades",
      campo: "Educación",
      tipo: "Maestría",
      imagen: "",
      url: "https://www.utpl.edu.ec/maestria-educacion-curriculo",
      periodo: "abril - agosto 2026",
      inicio: "abril 2026",
    },
    {
      titulo: "Educación mención en Gestión del Aprendizaje mediado por TIC",
      modalidad: "en línea",
      duracion: "1 año",
      facultad: " Facultad de Ciencias Sociales, Educación y Humanidades",
      campo: "Educación",
      tipo: "Maestría",
      imagen: "",
      url: "https://www.utpl.edu.ec/maestrias/aprendizajetic",
      periodo: "abril - agosto 2026",
      inicio: "abril 2026",
    },
    {
      titulo: "Educación mención en Innovación y Liderazgo Educativo",
      modalidad: "en línea",
      duracion: "1 año",
      facultad: " Facultad de Ciencias Sociales, Educación y Humanidades",
      campo: "Educación",
      tipo: "Maestría",
      imagen: "",
      url: "https://www.utpl.edu.ec/maestrias/educacioninnovacion",
      periodo: "abril - agosto 2026",
      inicio: "abril 2026",
    },
    {
      titulo:
        "Educación, Mención 1. Orientación Familiar, Mención 2. Orientación Educativa",
      modalidad: "en línea",
      duracion: "1 año",
      facultad: " Facultad de Ciencias Sociales, Educación y Humanidades",
      campo: "Educación",
      tipo: "Maestría",
      imagen: "",
      url: "https://www.utpl.edu.ec/maestrias/educacion",
      periodo: "abril - agosto 2026",
      inicio: "abril 2026",
    },
    {
      titulo: "Finanzas",
      modalidad: "en línea",
      duracion: "1 año",
      facultad: "Facultad de Ciencias Económicas y Empresariales",
      campo: "Administración",
      tipo: "Maestría",
      imagen: "",
      url: "https://www.utpl.edu.ec/maestrias/finanzas",
      periodo: "abril - agosto 2026",
      inicio: "abril 2026",
    },
    {
      titulo: "Gestión de Proyectos",
      modalidad: "en línea",
      duracion: "1 año",
      facultad: "Facultad de Ciencias Económicas y Empresariales",
      campo: "Ciencias Sociales, Periodismo e Información",
      tipo: "Maestría",
      imagen: "",
      url: "https://www.utpl.edu.ec/maestrias/proyectos",
      periodo: "abril - agosto 2026",
      inicio: "abril 2026",
    },
    {
      titulo: "Industria 4.0 con mención en Transformación Digital",
      modalidad: "en línea",
      duracion: "1 año",
      facultad: "Facultad de Ingenierías y Arquitectura",
      campo: "Ingeniería, Industria y Construcción",
      tipo: "Maestría",
      imagen: "",
      url: "https://www.utpl.edu.ec/maestrias/industria",
      periodo: "abril - agosto 2026",
      inicio: "abril 2026",
    },
    {
      titulo: "Inteligencia Artificial Aplicada",
      modalidad: "en línea",
      duracion: "1 año",
      facultad: "Facultad de Ingenierías y Arquitectura",
      campo: "Tecnologías de la Información y la Comunicación (TIC)",
      tipo: "Maestría",
      imagen: "",
      url: "https://www.utpl.edu.ec/maestrias/inteligencia-artificial",
      periodo: "abril - agosto 2026",
      inicio: "abril 2026",
    },
    {
      titulo: "Planificación del Territorio",
      modalidad: "en línea",
      duracion: "1 año",
      facultad: "Facultad de Ingenierías y Arquitectura",
      campo: "Ciencias Sociales, Periodismo, Información y Derecho",
      tipo: "Maestría",
      imagen: "",
      url: "https://www.utpl.edu.ec/maestrias/territorio",
      periodo: "abril - agosto 2026",
      inicio: "abril 2026",
    },
    {
      titulo: "Producción y Operaciones Industriales",
      modalidad: "en línea",
      duracion: "1 año",
      facultad: " Facultad de Ciencias Exactas y Naturales",
      campo: "Ciencias Naturales, Matemáticas y Estadística",
      tipo: "Maestría",
      imagen: "",
      url: "https://utpl.edu.ec/maestrias/produccion",
      periodo: "abril - agosto 2026",
      inicio: "abril 2026",
    },
    {
      titulo: "Doctorado en Química",
      modalidad: "presencial",
      duracion: "4 años",
      facultad: "Facultad de Ciencias Exactas y Naturales",
      campo: "Ciencias Naturales, Matemáticas y Estadística",
      tipo: "Doctorado",
      imagen: "",
      url: "https://utpl.edu.ec/doctorado-quimica/",
      periodo: "",
      inicio: "Próximamente",
    },
    {
      titulo:
        "Recursos Naturales Renovables con mención en Manejo y Preservación de los Recursos Naturales",
      modalidad: "en línea",
      duracion: "1 año",
      facultad: " Facultad de Ciencias Exactas y Naturales",
      campo: "Ciencias Naturales, Matemáticas y Estadística",
      tipo: "Maestría",
      imagen: "",
      url: "https://www.utpl.edu.ec/maestrias/recursosnaturales",
      periodo: "abril - agosto 2026",
      inicio: "abril 2026",
    },
    // Agrega los demás programas aquí con la misma estructura...
  ];
  const handleChangePeriodo = (selected) => {
    setPeriodo(selected);
  };
  const handleChangeModalidad = (selected) => {
    setModalidad(selected);
  };
  const handleChangeTipo = (selected) => {
    setTipo(selected);
  };
  const handleChangeCampo = (selected) => {
    setCampo(selected);
  };

  const programasFiltrados = programas.filter((p) => {
    const coincidePeriodo =
      !periodo ||
      periodo.value === "todos" ||
      p.periodo.toLowerCase() === periodo.value.toLowerCase();

    const coincideModalidad =
      !modalidad ||
      modalidad.value === "todos" ||
      p.modalidad.toLowerCase() === modalidad.value.toLowerCase();

    const coincideTipo =
      !tipo ||
      tipo.value === "todos" ||
      p.tipo.toLowerCase() === tipo.value.toLowerCase();

    const coincideCampo =
      !campo ||
      campo.value === "todos" ||
      p.campo.toLowerCase() === campo.value.toLowerCase();

    return (
      coincidePeriodo && coincideModalidad && coincideTipo && coincideCampo
    );
  });

  return (
    <div>
      <div className="bloque1 flex-center new-offer">
        <div>
          <p>
            <b>Oferta</b>
          </p>
          <Select
            options={optionsoferta}
            defaultValue={optionsoferta[0]}
            onChange={handleChangePeriodo}
          />
        </div>

        <div>
          <p>
            <b>Modalidad</b>
          </p>
          <Select
            options={optionsmodalidad}
            defaultValue={optionsmodalidad[0]}
            onChange={handleChangeModalidad}
          />
        </div>
        <div>
          <p>
            <b>Tipo</b>
          </p>
          <Select
            options={optionstipo}
            defaultValue={optionstipo[0]}
            onChange={handleChangeTipo}
          />
        </div>

        <div>
          <p>
            <b>Campo</b>
          </p>
          <Select
            options={optionscampo}
            defaultValue={optionscampo[0]}
            onChange={handleChangeCampo}
          />
        </div>
      </div>

      <div className="bloque2 margin">
        <div className="wrapper-academicoffer">
          {programasFiltrados.map((programa, index) => (
            <div key={index}>
              {programa.imagen && (
                <div className="programa-imagen">
                  <img src={programa.imagen} alt={programa.titulo} />
                </div>
              )}
              <div className="layout8">
                <div className="flex-start">
                  <p className="tipoposgrado"> {programa.tipo}</p>
                  {IsTag(programa.tag)}
                </div>

                <h3>{programa.titulo}</h3>
                <p>
                  <b>Modalidad: </b>
                  {programa.modalidad}
                </p>
                <p>
                  <b>Duración:</b> {programa.duracion}
                </p>
                <p>
                  <b>Campo del conocimiento: </b>
                  {programa.campo}
                </p>
                <p>
                  <b>Facultad: </b>
                  {programa.facultad}
                </p>
          {/*       {programa.periodo && (
                  <p>
                    <b>Periodo: </b>
                    {programa.periodo}
                  </p>
                )} */}
                {programa.inicio && (
                  <p>
                    <b>Inicio de clases: </b>
                    {programa.inicio}
                  </p>
                )}
                <div className="wrapper-link">
                  <a
                    className="link-offer"
                    href={programa.url}
                    target="_blank"
                    rel="noreferrer"
                  >
                    Ver programa
                    <span className="material-icons">arrow_forward_ios</span>
                  </a>
                </div>
              </div>
            </div>
          ))}
          {programasFiltrados.length === 0 && (
            <p>No hay programas disponibles.</p>
          )}
        </div>
      </div>
    </div>
  );
}

export default OfferPosgrados;
